export interface CampaignEvent {
  eventId: string;
  name: string;
  startsAt: string | null;
  maxPlaces: number | null;
  disabled: boolean;
  disabledReason: string | null;
}

export interface CampaignConfig {
  id: string;
  name: string;
  instructions: string | null;
  maxPlacesPerEvent: number | null;
  maxPlacesTotal: number | null;
  disabled: boolean;
  disabledReason: string | null;
  events: CampaignEvent[];
}

export interface SubmittedItem {
  eventId: string;
  eventName: string;
  places: number;
}

export interface SubmittedCampaignRequest {
  submittedAt: string;
  firstName: string;
  lastName: string;
  email: string;
  requestedTrough: string;
  message: string;
  items: SubmittedItem[];
}

export interface ValidationErrors {
  [key: string]: string[];
}

export const CAMPAIGN_SUBMITTED_STORAGE_KEY = (campaignId: string) =>
  `guestlist-campaign-submitted:${campaignId}`;
